import sendRequest from "@/libs/sendRequest"

// Manual host payouts. The list shows what each completed trip owes the host
// (amount_mxn) plus the host's bank details (bank_name, code[=CLABE],
// account_holder_name); markAsPaid records a manual bank transfer.
const payouts = {
    namespaced: true,
    state: {
        payouts: [],
        total_pages: null,
        last_page: null,
        error: false
    },
    getters: {
        getPayouts: (state) => state.payouts,
        getTotalPages: (state) => state.total_pages,
        getLastPage: (state) => state.last_page,
        getError: (state) => state.error
    },
    mutations: {
        setPayouts: (state, payload) => state.payouts = payload,
        setTotalPages: (state, payload) => state.total_pages = payload,
        setLastPage: (state, payload) => state.last_page = payload,
        setError: (state, payload) => state.error = payload
    },
    actions: {
        list: async({ commit, dispatch, rootGetters }, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/payouts/list', 'GET', null, query, custom_headers)

            if(response.success && response.data) {
                if(query.datatable) {
                    commit('setPayouts', response.data.list?.result ?? [])
                    commit('setTotalPages', response.data.list?.total_pages)
                    commit('setLastPage', response.data.list?.total_pages == query.page)
                }
                else {
                    commit('setPayouts', response.data.list ?? [])
                }
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        markAsPaid: async({ commit, dispatch, rootGetters }, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/payouts/mark_paid', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Payout marked as paid', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_reference':
                            messages.push('Error: Transfer reference required.')
                            break
                        case 'error_payout_already_paid':
                            messages.push('Error: This payout is already paid.')
                            break
                        case 'error_payout_not_found':
                            messages.push('Error: Payout not found.')
                            break
                        default:
                            messages.push('An error has occurred try later')
                            break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        }
    }
}

export default payouts
